module.exports = __webpack_public_path__ + "media/images/small-circle-26115c211ba50621a0e27e6f7bcf783b.svg";